import React from 'react';

const Footer = () => {
  return(
  <footer className="text-center py-3">&copy; 2017 by <a href="https://alisher.me">Alisher Musurmonov</a> & <a href="hhtps://aliglob.com" className="font-underline">Ali Globalization</a></footer>
  )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/parcials/footer.jsx